// src/pages/Dashboard.js
import React from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Icons
import CreateIcon from "@mui/icons-material/Create"; // Create Paper
import FolderIcon from "@mui/icons-material/Folder"; // My Papers
import QuizIcon from "@mui/icons-material/Quiz"; // My Questions
import BrushIcon from "@mui/icons-material/Brush"; // School Branding

export default function Dashboard() {
  const navigate = useNavigate();

  const folders = [
    {
      title: "Create Paper",
      description: "Generate question papers easily.",
      icon: <CreateIcon sx={{ fontSize: 30, color: "#f1faee" }} />,
      path: "/create-question",
    },
    {
      title: "My Papers",
      description: "View all your generated papers.",
      icon: <FolderIcon sx={{ fontSize: 30, color: "#f1faee" }} />,
      path: "/Pdf-View",
    },
    {
      title: "My Questions",
      description: "Manage your question bank.",
      icon: <QuizIcon sx={{ fontSize: 30, color: "#f1faee" }} />,
      path: "/Not-Found",
    },
    {
      title: "School Branding",
      description: "Upload logo, header, and footer.",
      icon: <BrushIcon sx={{ fontSize: 30, color: "#f1faee" }} />,
      path: "/Not-Found",
    },
  ];

  return (
    <Box
      sx={{
        flexGrow: 1,
        py: 6,
        px: 2,
        background: "linear-gradient(135deg, #f0f4ff, #f9f9f9)",
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {folders.map((folder, idx) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: "0px 6px 16px rgba(0,0,0,0.08)",
                cursor: "pointer",
                textAlign: "center",
                p: 4,
                transition: "all 0.3s ease",
                backgroundColor: "white",
                "&:hover": {
                  boxShadow: "0px 12px 24px rgba(0,0,0,0.15)",
                  transform: "translateY(-8px) scale(1.02)",
                },
              }}
              onClick={() => navigate(folder.path)}
            >
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                  background:
                    "linear-gradient(135deg, #4884ecff 0%, #2575fc 100%)",
                  color: "#fff",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                }}
              >
                {folder.icon}
              </Box>

              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{ color: "#222" }}
              >
                {folder.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                {folder.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
